import React, { useEffect, useState } from 'react';
import { useParams, useHistory } from 'react-router';
import Loader from '../blocks/Loader';
import NotFound from '../../scenes/NotFound';
import * as api from '../../utils/api';
import { getCityUrlFromPath, getShopUrl } from '../../utils/utils';
import {
  ANNUAIRE_ROOT,
  annuairePathFromUrlPath,
} from '../../annuaire/resolvePath';
import { decideDeadAnnuairePath } from '../../annuaire/resolveClient';

// Miroir client de `app.get('/ateliers-reparation/:id(\d+)/:name?')`
// (src/server/index.jsx). Les deux doivent raconter la même histoire : le SSR
// monte l'app avec `render()` et non `hydrate()`, donc c'est ce composant qui a
// le dernier mot dans le navigateur.
export default function WorkshopRedirect() {
  const { id } = useParams();
  const history = useHistory();
  // null | 404 | 410
  const [missingCode, setMissingCode] = useState(null);

  useEffect(() => {
    let cancelled = false;

    async function resolve() {
      try {
        const data = await api.get(`/shops/resolve/${id}`);
        if (cancelled) return;

        if (data && data.url_path && !data.deleted) {
          history.replace(getShopUrl(data));
          return;
        }

        if (data && data.deleted && data.url_path) {
          // La destination d'une fiche supprimée est portée par sa Redirection :
          // un DOUBLON va vers la fiche conservée, pas vers la page ville, et une
          // FICHE_ERRONEE ne va nulle part. Deviner ici donnait une destination
          // fausse.
          const decision = await decideDeadAnnuairePath(
            annuairePathFromUrlPath(data.url_path),
            getCityUrlFromPath(data.url_path),
          );
          if (cancelled) return;
          if (decision.type === 'redirect') {
            history.replace(decision.location);
            return;
          }
          if (decision.type === 'gone' || decision.type === 'notFound') {
            setMissingCode(decision.type === 'gone' ? 410 : 404);
            return;
          }
          // 'unavailable' : l'api ne répond pas. On ne prétend pas que la fiche
          // n'existe pas (ce serait mentir), et on ne laisse pas un loader
          // éternel : on retombe sur ce que cette route faisait avant ce lot,
          // une redirection client vers la page ville. Aucun code HTTP n'est en
          // jeu ici — le SSR a déjà servi le sien.
          console.error('[annuaire] résolution client indisponible pour', id);
          history.replace(getCityUrlFromPath(data.url_path));
          return;
        }

        if (data && data.deleted && data.city_slug) {
          // Fiche sans url_path : aucun chemin d'annuaire n'a vécu, donc aucune
          // Redirection possible. Comportement inchangé.
          history.replace(`${ANNUAIRE_ROOT}/${data.city_slug}`);
          return;
        }

        setMissingCode(404);
      } catch (e) {
        if (!cancelled) setMissingCode(404);
      }
    }

    resolve();
    return () => {
      cancelled = true;
    };
  }, [id, history]);

  if (missingCode) return <NotFound code={missingCode} />;

  return <Loader />;
}
